export const CLIENT_STATUS_ACTIVE = 76;
export const CLIENT_STATUS_LOCKED = 77;

export const initialState = {
  loading: false,
  list: {},
  item: {},
  error: undefined,
  insuranceLosses: [],
  serviceCards: [],
};

export const RESET_ERROR = 'clients/RESET_ERROR';

export const FIND_CLIENT = 'clients/FIND_CLIENT';
export const FIND_CLIENT_FAIL = 'clients/FIND_CLIENT_FAIL';
export const FIND_CLIENT_SUCCESS = 'clients/FIND_CLIENT_SUCCESS';
export const FETCH_CLIENT = 'clients/FETCH_CLIENT';
export const FETCH_CLIENT_FAIL = 'clients/FETCH_CLIENT_FAIL';
export const FETCH_CLIENT_SUCCESS = 'clients/FETCH_CLIENT_SUCCESS';
export const CREATE_CLIENT = 'clients/CREATE_CLIENT';
export const CREATE_CLIENT_FAIL = 'clients/CREATE_CLIENT_FAIL';
export const CREATE_CLIENT_SUCCESS = 'clients/CREATE_CLIENT_SUCCESS';
export const UPDATE_CLIENT = 'clients/UPDATE_CLIENT';
export const UPDATE_CLIENT_FAIL = 'clients/UPDATE_CLIENT_FAIL';
export const UPDATE_CLIENT_SUCCESS = 'clients/UPDATE_CLIENT_SUCCESS';
export const DELETE_CLIENT = 'clients/DELETE_CLIENT';
export const DELETE_CLIENT_FAIL = 'clients/DELETE_CLIENT_FAIL';
export const DELETE_CLIENT_SUCCESS = 'clients/DELETE_CLIENT_SUCCESS';
export const FETCH_CLIENT_INSURANCE_LOSSES_SUCCESS = 'clients/FETCH_CLIENT_INSURANCE_LOSSES_SUCCESS';
export const FETCH_CLIENT_INSURANCE_LOSSES_FAIL = 'clients/FETCH_CLIENT_INSURANCE_LOSSES_FAIL';
export const FETCH_CLIENT_SERVICE_CARDS_SUCCESS = 'clients/FETCH_CLIENT_SERVICE_CARDS_SUCCESS';
export const FETCH_CLIENT_SERVICE_CARDS_FAIL = 'clients/FETCH_CLIENT_SERVICE_CARDS_FAIL';
